import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import NavBar from '../components/NavBar'
import FrTextInput from '../components/FrTextInput'
import FrSelect from '../components/FrSelect'
import UserOptions from '../components/UserOptions'
import FrLoading from '../components/FrLoading'
import FrSelectAgrupado from '../components/FrSelectAgrupado'

import api from '../services/api'
import { paramsToObject } from '../utils/functions'

import './styles/DefaultReg.css';
import { colors } from '../utils/vars'
import FooterDelphus from '../components/FooterDelphus';
import { Icon } from "react-icons-kit";
import { ic_add_box } from 'react-icons-kit/md/ic_add_box'
import FrTableReg from '../components/FrTableReg'

const swal = withReactContent(Swal)

function Plano_Contas(props) {
  const [data, setData] = useState({})
  const [updateType, setUpdateType] = useState(false)
  const [enableEdit, setEnableEdit] = useState('N')
  const [comboTpc, setComboTpc] = useState([{ value: '', display: '' }])
  const [comboPlc, setComboPlc] = useState([{ value: '', display: '' }])
  const [comboFormula, setComboFormula] = useState([{ value: '+', display: '+' }, { value: '-', display: '-' }])
  const [dataPlf, setDataPlf] = useState([{ value: '', display: '', nomeplc: '' }])

  const columnsPlf = [{ id: 'operacao', numeric: false, label: 'Operação', align: 'left', minWidth: 100 },
  { id: 'nomeplc', numeric: false, label: 'Plano', align: 'left', minWidth: 400 },

  ]

  useEffect(() => {
    const fetchData = async () => {
      swal.fire({
        html: <FrLoading text="Carregando..." />,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })
      const urlParams = new URLSearchParams(window.location.search);
      let query = paramsToObject(urlParams)

      if (query.codigo > 0) {
        setEnableEdit(await api.getAcessos('Plano Contas', 'Alteracao'))
      } else {
        setEnableEdit(await api.getAcessos('Plano Contas', 'Inclusao'))
      }

      setComboTpc(await api.getComboData('tipo_conta_plano'))
      setComboPlc(await api.getComboData('plano_contas'))

      if (query.codigo > 0) {
        setUpdateType(true)
        api.get('/plano_contas?pk_plc=' + query.codigo).then(r => {
          if (r.data[0]) {
            setData(r.data[0])
            api.get('/plano_contas/formulas?fk_plc=' + query.codigo).then(r => {
              if (r.data.length > 0)
                setDataPlf(r.data)
              swal.close()
            })
          } else {
            swal.fire('Código inválido', 'Código informado não encontrado!', 'warning')
              .then((result) => {
                if (result.value) {
                  window.history.back()
                }
              })
          }
        })
      } else swal.close()
    }

    fetchData()
  }, [])

  function consistData(data) {
    let required = [
      'descricao',
      'fk_tpc'
    ]

    let errors = []

    required.forEach((curr, index) => {
      let fieldName = curr
      if (fieldName == 'fk_tpc')
        fieldName = 'Tipo'
      if (!data[curr]) return errors.push(fieldName)
    })

    return errors
  }

  function handleSubmit(e) {
    e.preventDefault();
    swal.fire({
      title: `<h2 style='color:${colors.info900}'>ATENÇÃO</h2>`,
      html: `<p style='color:${colors.info900}'>Deseja salvar ${updateType ? 'as alterações' : 'a inclusão'} do registro?</p>`,
      icon: 'question',
      color: colors.info900,
      showCancelButton: true,
      confirmButtonColor: colors.success500,
      cancelButtonColor: colors.danger500,
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then((result) => {
      if (result.value) {
        const auxValues = { ...data };
        auxValues.dataPlf = dataPlf;
        let errors = consistData(auxValues)
        if (errors.length === 0) {
          if (updateType) {
            api.post('/plano_contas/edit', auxValues).then(r => {
              if (r.status === 200) {
                swal.fire({
                  title: `<h2 style='color: ${colors.info900}'>Registro Alterado<h2>`,
                  html: `<p style='color: ${colors.info900}'>O registro foi alterado com sucesso!</p>`,
                  icon: 'success',
                }).then((result) => {
                  if (result.value) {
                    window.history.back()
                  }
                })
              } else {
                swal.fire({
                  title: `<h2 style='color: ${colors.info900}'>Erro!</h2>`,
                  html: `<p style='color: ${colors.info900}'></p>`,
                  icon: 'warning',
                })
              }
            })
          } else {
            try {
              api.post('/plano_contas/add', auxValues).then(r => {
                if (r.status === 200) {
                  swal.fire({
                    title: 'Registro Adicionado',
                    text: "O registro foi adicionado com sucesso!",
                    icon: 'success',
                  }).then((result) => {
                    if (result.value) {
                      window.history.back()
                    }
                  })
                } else {
                  swal.fire({
                    title: `<h2 style='color: ${colors.info900}'>Erro!</h2>`,
                    text: "O registro não foi adicionado!",
                    icon: 'warning',
                  })
                }
              })
            } catch {
              swal.fire({
                title: `<h2 style='color: ${colors.info900}'>Erro!</h2>`,
                text: "O registro não foi adicionado!",
                icon: 'warning',
              })

            }

          }
        } else {
          swal.fire({
            title: `<h2 style='color: ${colors.info900}'>Erro!</h2>`,
            text: "Verifique o(s) campo(s) " + errors.join(','),
            icon: 'warning',
          })
        }
      }
    })
  }

  function handleCancel(e) {
    e.preventDefault();
    swal.fire({
      title: `<h2 style='color:${colors.info900}'>ATENÇÃO</h2>`,
      html: `<p style='color: ${colors.info900}'>Caso cancele a alteração/inclusão, todos os dados digitados serão perdidos. Confirma?<p>`,
      icon: 'warning',
      color: colors.info900,
      showCancelButton: true,
      confirmButtonColor: colors.success500,
      cancelButtonColor: colors.danger500,
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then((result) => {
      if (result.value) {
        window.history.back()
      }
    })
  }

  const handleChange = (e) => {
    const auxValues = { ...data };
    switch (e.target.name) {
      default: auxValues[e.target.name] = e.target.value;
    }
    setData(auxValues);
  };

  async function insertPlf(e) {
    e.preventDefault();
    if ((!data.fk_plc) || (!data.formula)) {
      swal.fire({
        title: `<h2 style='color: ${colors.info900}'>Erro!</h2>`,
        text: "Informe o plano e a operação!",
        icon: 'warning',
      })

    } else {

      let pk = 1
      let nomeplc = ''

      await api.get('/plano_contas?pk_plc=' + data.fk_plc).then(r => {
        if (r.data.length > 0)
          nomeplc = r.data[0].descricao
      })

      let item = [{
        nomeplc: nomeplc,
        operacao: data.formula,
        pk: pk,
        cod_operando: data.fk_plc
      }]
      pk++
      var i;
      for (i = 0; i < dataPlf.length; i++) {
        if (dataPlf[i].nomeplc !== '')
          item.push({
            nomeplc: dataPlf[i].nomeplc,
            operacao: dataPlf[i].operacao,
            pk: pk,
            cod_operando: dataPlf[i].cod_operando
          })
        pk++
      }
      setDataPlf(item)
    }
  }


  return (
    <div className="defaultReg">
      <NavBar />
      <div className="defaultRegContent">
        <div className="defaultHeader">
          <h3>{updateType ? 'Edição' : 'Inclusão'} de Plano de Conta</h3>
          <UserOptions temaEscuro={props.temaEscuro} setTemaEscuro={props.setTemaEscuro} />
        </div>
        <br />
        <form id="regForm" onSubmit={handleSubmit}>

          <FrTextInput
            maxLength='50'
            value={data.descricao || ''}
            onChange={handleChange}
            name="descricao"
            id="descricao"
            color="#389492"
            label="Descrição"
            variant="outlined"
            size="small"
            required
            style={{ width: 300 }}
            autoFocus
          />


          <FrSelect
            value={data.fk_tpc || ''}
            onChange={handleChange}
            name="fk_tpc"
            id="fk_tpc"
            label='Tipo'
            data={comboTpc}
            style={{ width: 150 }}
          />

          <div hidden={data.fk_tpc != 3}>
            <br />

            <FrTextInput
              maxLength='50'
              value={data.ordem_relatorio || ''}
              onChange={handleChange}
              name="ordem_relatorio"
              id="ordem_relatorio"
              color="#389492"
              label="Ordem Relatório"
              variant="outlined"
              size="small"
              style={{ width: 130 }}
            />
            <br />
            <FrSelect
              value={data.formula || ''}
              onChange={handleChange}
              name="formula"
              id="formula"
              label=''
              data={comboFormula}
              style={{ width: 60 }}
            />

            <FrSelectAgrupado
              value={data.fk_plc || ''}
              onChange={handleChange}
              name="fk_plc"
              id="fk_plc"
              label=''
              data={comboPlc}
              style={{ width: 300 }}
              group={'nometpc'}
            />
            <button className='incluiFileButton' style={{ width: '90px' }} onClick={insertPlf} >
              <Icon icon={ic_add_box} size={18} />
            </button>
            <br />
            <FrTableReg
              setDataGrid={setDataPlf} detail regName="" columns={columnsPlf} searched={false} codeName="display"
              page={''} data={dataPlf}
            />

          </div>
        </form>
        <div className="regButtonsDiv">
          {enableEdit === 'S' ?
            (<button onClick={handleSubmit}>Salvar</button>) : (<></>)}
          <button onClick={handleCancel}>{enableEdit === 'S' ? 'Cancelar' : 'Fechar'}</button>
        </div>
        <FooterDelphus />
      </div>
    </div>
  );
}

export default Plano_Contas;
